import { makeStyles } from '@material-ui/styles'
import React, { FC } from 'react'
import Text from 'core/elements/Text'
import Theme from 'core/themes/model'

interface CardViewContainerProps<T> {
  data: any[]
  CardComponent: FC<{ item: T }>
  uniqueIdentifier: keyof T
  emptyText?: string
}

const CardViewContainer = <T extends Record<string, any>>({
  data,
  CardComponent,
  uniqueIdentifier,
  emptyText,
}: CardViewContainerProps<T>) => {
  const classes = useStyles()

  if (!data?.length)
    return (
      <div className={classes.emptyContainer}>
        <Text variant="subtitle2">{emptyText ? emptyText : 'No data found'}</Text>
      </div>
    )

  return (
    <div className={classes.cardsContainer}>
      {data?.map(({ item }) => (
        <CardComponent key={String(item[uniqueIdentifier])} item={item} />
      ))}
    </div>
  )
}

export default CardViewContainer

const useStyles = makeStyles<Theme>((theme) => ({
  cardsContainer: {
    display: 'flex',
    flexWrap: 'wrap',
    gap: theme.spacing(3),
  },
  emptyContainer: {
    display: 'flex',
    justifyContent: 'center',
    alignItems: 'center',
    marginTop: theme.spacing(5),
  },
}))
